import { SVGProps } from 'react';

const IconClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M16 0C7.16647 0 0 7.16646 0 16C0 24.8335 7.16647 32 16 32C24.8335 32 32 24.8335 32 16C32 7.16646 24.8335 0 16 0ZM11.7071 10.2929C11.3166 9.90237 10.6834 9.90237 10.2929 10.2929C9.90238 10.6834 9.90238 11.3166 10.2929 11.7071L14.5858 16L10.2929 20.2929C9.90238 20.6834 9.90238 21.3166 10.2929 21.7071C10.6834 22.0976 11.3166 22.0976 11.7071 21.7071L16 17.4142L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L17.4142 16L21.7071 11.7071C22.0976 11.3166 22.0976 10.6834 21.7071 10.2929C21.3166 9.90237 20.6834 9.90237 20.2929 10.2929L16 14.5858L11.7071 10.2929Z" fill="currentColor" />
  </svg>

);

export default IconClose;
